export default __webpack_public_path__ + "fd0dbc02080f15ec9a210dcc8ac48b39.png";